export const black = {
  20: 'rgba(17,19,20,0.2)',
  40: 'rgba(17,19,20,0.4)',
  60: 'rgba(17,19,20,0.6)',
  80: 'rgba(17,19,20,0.8)',
  100: '#111314',
  200: '#101213'
};
